import { BasePayloadMapper } from '@ps/utils';

import { SetPasswordPayloadDto } from '../dtos/auth.dto';
import { SetPasswordCredentials } from '../../models/auth.model';

export class SetPasswordPayloadMapper extends BasePayloadMapper<
  SetPasswordCredentials,
  SetPasswordPayloadDto
> {
  public toPayload(data: SetPasswordCredentials): SetPasswordPayloadDto {
    return {
      newpass: data.newPassword,
      cpass: data.confirmPassword,
    };
  }
}
